"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../common/utils");
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// THIS CLASS IS DEPRECATED. IT SHOULD NOT BE EXTENDED.
var DefunctDynamicComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(DefunctDynamicComponent, _React$Component);
  var _super = _createSuper(DefunctDynamicComponent);
  function DefunctDynamicComponent(props) {
    var _this;
    _classCallCheck(this, DefunctDynamicComponent);
    _this = _super.call(this, props);
    _this.save = function () {
      _this.updateData();
    };
    // allow a component to submit data to a secondary path
    _this.saveValueToDataPath = function (value, dataPath) {
      _this.props.saveData(dataPath, value);
    };
    _this.updateData = function () {
      var value = _this.state[_this.props.dataPath];
      _this.props.saveData(_this.props.dataPath, value);
    };
    _this.validateAllContent = function (fullConfigObj) {
      var content = {
        contents: fullConfigObj.contents,
        validations: fullConfigObj.validations
      };
      _this.setState({
        fullValidationRun: true
      });
      var result = _this.validateCurrent(content, {
        errorObj: {},
        contentValid: true
      });
      _this.props.saveDataErrors('', result.errorObj);
      return result.contentValid;
    };
    _this.validateContinueClick = function (callback) {
      if (_this.state.fullValidationRun || _this.validateAllChildren(callback)) {
        _this.props.navNext();
        _this.setState({
          fullValidationRun: false
        });
      }
    };
    _this.validateAllChildren = function (callback) {
      var content = {
        contents: _this.props.contents,
        validations: _this.props.validations,
        dataPath: _this.props.dataPath
      };
      _this.setState({
        fullValidationRun: true
      });
      var result = _this.validateCurrent(content, {
        errorObj: {},
        contentValid: true
      });
      _this.props.saveDataErrors('', result.errorObj);
      var value = false;
      if (typeof callback === 'function') {
        value = callback(result.errorObj);
      }
      return result.contentValid || value;
    };
    _this.validateCurrent = function (content, result) {
      var validations = content.validations,
        contents = content.contents;
      var errorObj = result.errorObj;
      var contentValid = result.contentValid;
      var v;
      if (validations) {
        for (var i = 0; i < validations.length; i++) {
          var val = validations[i];
          var field = val.field;

          // Incase fields are with in a table
          if (field && field.indexOf('_key_') !== -1) {
            var fieldArray = field.split('.');
            var firstField = fieldArray.shift();
            var complexResult = _this.validateComplex(firstField, fieldArray.slice(), val.rules, errorObj, contentValid);
            errorObj = complexResult.errorObj;
            contentValid = complexResult.contentValid;
          } else {
            v = _lodash.default.has(content, 'entityDataPath') ? _this.getDependencyData(field) : _this.getData(field);
            var errors = _this.validateRules(v, field, val.rules, []);
            var setResponse = _this.setErrorObjects(errorObj, field, errors, contentValid);
            contentValid = setResponse.contentValid;
            errorObj = setResponse.errorObj;
          }
        }
      }
      if (contents) {
        contents.forEach(function (content) {
          var contentResult = _this.validateCurrent(content, {
            errorObj: errorObj,
            contentValid: contentValid
          });
          errorObj = contentResult.errorObj;
          contentValid = contentResult.contentValid;
        });
      }
      return {
        errorObj: errorObj,
        contentValid: contentValid
      };
    };
    _this.setErrorObjects = function (errorObj, field, errors, contentValid) {
      var anyErrors = !_lodash.default.isEmpty(errors);
      if (anyErrors) {
        contentValid = false;
      }
      if (anyErrors || !_lodash.default.isEmpty(_lodash.default.get(_this.props.dataErrors, field))) {
        errorObj = _lodash.default.setWith(errorObj, field, errors);
      }
      return {
        errorObj: errorObj,
        contentValid: contentValid
      };
    };
    _this.validateComplex = function (field, array, rules, errorObj, contentValid) {
      var errors = [];
      if (_lodash.default.isEmpty(array)) {
        var value = _this.getData(field);
        //I don't like this...feels dirty...
        var runValidation = true;
        if ((0, _utils.checkIfValuesAre)([null, undefined], value) && field.lastIndexOf('.') !== -1) {
          var objField = field.substr(0, field.lastIndexOf('.'));
          var obj = _this.getData(objField);
          runValidation = obj ? !(0, _utils.hasChildren)(obj) : true;
        }
        if (runValidation) {
          errors = _this.validateRules(value, field, rules, errors);
          var setResponse = _this.setErrorObjects(errorObj, field, errors, contentValid);
          contentValid = setResponse.contentValid;
          errorObj = setResponse.errorObj;
        }
      } else {
        var spot = array.shift();
        if (spot === '_key_') {
          var _obj = _lodash.default.get(_this.props.allData.payload, field);
          for (var prop in _obj) {
            var complexResult = _this.validateComplex(field + '.' + prop, array.slice(), rules, errorObj, contentValid);
            errorObj = _objectSpread(_objectSpread({}, errorObj), complexResult.errorObj);
            contentValid = complexResult.contentValid;
          }
        } else {
          var _complexResult = _this.validateComplex(field + '.' + spot, array.slice(), rules, errorObj, contentValid);
          errorObj = _objectSpread(_objectSpread({}, errorObj), _complexResult.errorObj);
          contentValid = _complexResult.contentValid;
        }
      }
      return {
        errorObj: errorObj,
        contentValid: contentValid
      };
    };
    _this.displayError = function (fieldName) {
      if (_this.props.dataErrors === undefined) return false;
      var value = _lodash.default.get(_this.props.dataErrors, fieldName);
      return value !== undefined && !_lodash.default.isEmpty(value);
    };
    _this.errorMessages = function (fieldName) {
      if (_this.props.dataErrors === undefined) return [];
      var array = _lodash.default.get(_this.props.dataErrors, fieldName);
      if (array !== undefined) {
        return _lodash.default.uniq(array).map(function (value, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index
          }, (0, _reactHtmlParser.default)(value), " ");
        });
      }
      return [];
    };
    _this.validateFromState = function (fieldName, validations, value) {
      var name = fieldName;
      if (fieldName.lastIndexOf('.')) {
        name = (0, _utils.getLastFieldInPath)(fieldName);
      }
      var errors = [];
      var validation = _lodash.default.find(validations, function (obj) {
        var validationField = obj.field;
        if (obj.field !== undefined && obj.field.lastIndexOf('.')) {
          validationField = (0, _utils.getLastFieldInPath)(obj.field);
        }
        return validationField === name;
      });
      validation = validation !== undefined ? validation : {
        rules: []
      };
      errors = _this.validateRulesFromState(value, fieldName, validation.rules, errors);
      return _lodash.default.uniq(errors);
    };
    _this.validate = function (fieldName, validations, value) {
      var name = fieldName;
      if (fieldName.lastIndexOf('.')) {
        name = (0, _utils.getLastFieldInPath)(fieldName);
      }
      var errors = [];
      var validation = _lodash.default.find(validations, function (obj) {
        var validationField = obj.field;
        if (obj.field !== undefined && obj.field.lastIndexOf('.')) {
          validationField = (0, _utils.getLastFieldInPath)(obj.field);
        }
        return validationField === name;
      });
      validation = validation !== undefined ? validation : {
        rules: []
      };
      errors = _this.validateRules(value, fieldName, validation.rules, errors);
      return _lodash.default.uniq(errors);
    };
    _this.getData = function (dataPath) {
      return _lodash.default.get(_this.props.allData.payload, dataPath);
    };
    _this.getDependencyData = function (dataPath) {
      return _lodash.default.get(_this.props, dataPath);
    };
    _this.getDependencies = function (rule, field) {
      var depArgs = [];
      if (rule.dependencies) {
        rule.dependencies.forEach(function (dep) {
          // dependencies in data
          if (dep.indexOf('context.') === 0) {
            var depPathArray = dep.split('.');
            var depName = depPathArray.slice(1).join('.');
            var myDepValue = _this.getDependencyData(depName);
            depArgs.push(myDepValue);
          } else if (dep === '_config_') {
            depArgs.push(_this.props.config);
          } else if (dep === '_fieldName_') {
            depArgs.push(field);
          } else if (dep === 'sectionsStatus') {
            var _myDepValue = _this.getDependencyData("dynamicComponent.".concat(dep));
            depArgs.push(_myDepValue);
          } else {
            var _myDepValue2 = _this.getData(dep);
            depArgs.push(_myDepValue2);
          }
        });
      }
      return depArgs;
    };
    _this.validateRules = function (fieldValue, field, rules, errors) {
      var rulesMap = _this.props.rulesMap;
      var _iterator = _createForOfIteratorHelper(rules),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rule = _step.value;
          // Dependencies get added after args
          var ruleArgs = rule.args ? rule.args.slice() : [];
          ruleArgs.push.apply(ruleArgs, _toConsumableArray(_this.getDependencies(rule, field)));
          var myRule = rulesMap[rule.method].apply(rulesMap, _toConsumableArray(ruleArgs));
          var myRuleResult = void 0;
          // if there are nested rules, we need to pass those back
          var nestedRulesComposed = _lodash.default.get(myRule, 'nestedRulesComposed');
          if (nestedRulesComposed !== undefined) {
            var nestedRulesData = [];
            for (var i = 0; i < ruleArgs.length; i++) {
              var nestedRule = ruleArgs[i];
              var currArgs = nestedRule.args ? nestedRule.args.slice() : [];
              var currField = nestedRule.field;
              var fieldData = fieldValue;
              // ruleArgs contains the rules themselves
              currArgs.push.apply(currArgs, _toConsumableArray(_this.getDependencies(nestedRule, currField)));
              var argumentObj = {
                fieldData: fieldData,
                args: currArgs
              };
              nestedRulesData.push(argumentObj);
            }
            myRuleResult = nestedRulesComposed(nestedRulesData);
          } else {
            myRuleResult = myRule(fieldValue);
          }
          if (!myRuleResult) {
            errors.push(rule.message);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return errors;
    };
    _this.validateRulesFromState = function (value, field, rules, errors) {
      var rulesMap = _this.props.rulesMap;
      var _iterator2 = _createForOfIteratorHelper(rules),
        _step2;
      try {
        var _loop = function _loop() {
          var rule = _step2.value;
          // Dependencies get added after args
          var ruleArgs = rule.args ? rule.args.slice() : [];
          rule.dependencies && rule.dependencies.forEach(function (dep) {
            if (dep !== '_fieldName_') {
              var myDepValue = _lodash.default.get(_this.state, dep);
              ruleArgs.push(myDepValue);
            } else {
              ruleArgs.push(field);
            }
          });
          var myRule = rulesMap[rule.method].apply(rulesMap, _toConsumableArray(ruleArgs));
          if (!myRule(value)) {
            errors.push(rule.message);
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return errors;
    };
    // takes in an array, places a validation error on the first one
    _this.validateFieldFromState = function (fieldName) {
      var validations = _this.props.validations;
      var value = _lodash.default.get(_this.state, fieldName);
      if (validations) {
        var errors = _this.validateFromState(fieldName, validations, value);
        _this.props.saveDataErrors(fieldName, _lodash.default.uniq(errors));
        return _lodash.default.isEmpty(errors);
      }
    };
    _this.validateField = function (fieldName, asArray) {
      var validations = _this.props.validations;
      var value = _lodash.default.get(_this.state, fieldName);
      fieldName = asArray ? fieldName.join('.') : fieldName;
      if (validations) {
        var errors = _this.validate(fieldName, validations, value);
        _this.props.saveDataErrors(fieldName, _lodash.default.uniq(errors));
        return _lodash.default.isEmpty(errors);
      }
    };
    _this.validateSubfield = function (fieldName) {
      var validations = _this.props.validations;
      var value = _lodash.default.get(_this.state, fieldName.split('.'));
      if (validations) {
        var errors = _this.validate(fieldName, validations, value);
        _this.props.saveDataErrors(fieldName, _lodash.default.uniq(errors));
        return _lodash.default.isEmpty(errors);
      }
    };
    _this.props = props;
    _this.state = {
      fullValidationRun: false
    };
    return _this;
  }
  _createClass(DefunctDynamicComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.prePopped) {
        this.save();
      }
    }
  }, {
    key: "render",
    value:
    //if you have dependecides
    //check redux add map state to props
    //if you have go render
    // if not don't
    function render() {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
  }]);
  return DefunctDynamicComponent;
}(_react.default.Component);
DefunctDynamicComponent.propTypes = {
  title: _propTypes.default.string,
  guidance: _propTypes.default.string,
  type: _propTypes.default.string,
  dataPath: _propTypes.default.string,
  contents: _propTypes.default.array
};

// THIS CLASS IS DEPRECATED. IT SHOULD NOT BE EXTENDED.
var _default = DefunctDynamicComponent;
exports.default = _default;